import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/promotions',
    name: RouteName.Promotions,
    component: () => import('@/pages/Promotions/Promotions'),
    meta: {
      breadcrumb: {
        label: 'Акции',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/promotions/create',
    name: 'Создать Акцию',
    component: () => import('@/pages/Promotions/PromotionsCreate'),
    meta: {
      breadcrumb: {
        label: 'Новая акция',
        parent: RouteName.Promotions,
      },
    },
  },
  {
    path: '/promotions/:id',
    name: 'Акция',
    component: () => import('@/pages/Promotions/PromotionsSingle'),
    meta: {
      breadcrumb: {
        label: 'Редактирование акции',
        parent: RouteName.Promotions,
      },
    },
  },
]
